export default __webpack_public_path__ + "i18n/translations/translation-te.ca6fffdf.json";